export default class APIPendingApplications {
  constructor(API) {
    this.api = API;
  }

  async getTenantPendingApplications() {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/tenant/pendingApplications";
    return await req.exec();
  }

  async reviewPendingApplication(userID, certID, applicationType, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/certification/${certID}/application/${applicationType}/review`;
    req.body = body;
    return await req.exec();
  }

  async reviewPendingApplicationItem(
    userID,
    certProcID,
    sourceID,
    itemVersion,
    body
  ) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/certification/${certProcID}/applicationItem/${sourceID}/review/${itemVersion}`;
    req.body = body;
    return await req.exec();
  }

  async submitPreApprovalReview(userID, certID, applicationType, body) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/certification/${certID}/application/${applicationType}/preApprovalReview`;
    req.body = body;
    return await req.exec();
  }

  async removePendingApplicationItem(
    userID,
    certProcID,
    sourceID,
    itemVersion
  ) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/certification/${certProcID}/applicationItem/${sourceID}/remove/${itemVersion}`;
    return await req.exec();
  }
}
